import PropTypes from "prop-types";
import React, { useEffect, useState } from "react"
import { Container } from "reactstrap";
import WelcomeComp from "./WelcomeComp";
import { Link, useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { Row, Col, Card, Button, Modal, ModalBody } from "reactstrap"
import profileImg from "../../assets/images/profile-img.png"
import './dashboard.scss'
import { getLoggedInUser } from "../../helpers/fakebackend_helper"
import * as url from "../../../src/helpers/url_helper";
import VideoLink from "./videocarousel";
import './dashboard.scss';

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

//i18n
import { withTranslation } from "react-i18next";
import { RFC_2822 } from "moment/moment";
import SubscriptionPlanDetails from "./MySubscription";
import Draggable from 'react-draggable';
import mammoth from 'mammoth';
// import { FaExpand, FaTimes } from 'react-icons/fa';
const Dashboard = props => {
  //meta title
  document.title = "Dashboard | ICE - Student Portal";

  const navigate = useNavigate();
  const [isDisplayed, setIsDisplayed] = useState(false);
  const [Videolink, setVideoLink] = useState([])
  const [profilePercent, setProfilePercent] = useState(0)
  const [isExpanded, setIsExpanded] = useState(false);
  const [currentVideo, setCurrentVideo] = useState("");
  const [activeSubscriptionExist, setActiveSubscriptionExist] = useState(0)
  const [demoFlag, setDemoFlag] = useState(0)
  const [content, setContent] = useState('');

  // useEffect(() => {
  //   fetch('http://localhost:8082/getTerms')
  //     .then(res => res.blob())
  //     .then(blob => blob.arrayBuffer())
  //     .then(arrayBuffer =>
  //       mammoth.convertToHtml({ arrayBuffer })
  //     )
  //     .then(result => {
  //       setContent(result.value); // result.value is HTML string
  //     })
  //     .catch(err => {
  //       console.error('Error reading .docx:', err);
  //     });
  // }, []);

  const toggleModal = () => {

    setIsExpanded(!isExpanded)
    // setCurrentVideo(curr)

  };
  useEffect(() => {
    const user = getLoggedInUser()
    setProfilePercent(user.UserInfo.profilePercentage)
    setActiveSubscriptionExist(user.UserInfo.activeSubscriptionExist)

    fetchLink()
  }, []);
  useEffect(() => {
    if (Videolink && Videolink.length > 0) {
      setIsDisplayed(true);

    }
  }, [Videolink]);


  const updateActiveSubscriptionExist = (newValue) => {
    const authUserString = localStorage.getItem("authUser");

    if (authUserString) {
      try {
        const authUser = JSON.parse(authUserString);
        if (authUser.UserInfo) {
          authUser.UserInfo.activeSubscriptionExist = newValue;
          localStorage.setItem("authUser", JSON.stringify(authUser));
        }
      } catch (error) {
        console.error("Error updating localStorage:", error);
      }
    }
  };
  const fetchLink = async () => {
    const user = getLoggedInUser()

    const data = {
      stid: Number(user.UserInfo.stid),
    }
    const config = { headers: { authorization: 'Bearer '.concat(user.UserInfo.accessToken) } };

    try {
      const response = await axios.post(url.BASE_URL + 'master/getVideolist', data, config);
      if (response && response?.data?.body?.statusFlag === 3) {
        toast.error(response.data.body.message, { autoClose: 2000 });
        localStorage.removeItem("authUser");
        window.location.reload();
        return;
      }

      if (response?.data?.body?.status === '401' || response?.data?.body?.status === 401) {
        const refresh = await getRefreshToken();

        if (refresh) {
          if (Number(refresh) === constants.invalidRefreshToken) {
            logoutUser();
          } else {
            await fetchLink();
          }
        }
      }

      if (response?.data?.body?.videoList) {

        setActiveSubscriptionExist(response?.data?.body?.activeSubscriptionExist)
        updateActiveSubscriptionExist(response?.data?.body?.activeSubscriptionExist)
        setDemoFlag(response?.data?.body?.demoFlag)
        var filtered_videos = response?.data?.body?.videoList.filter(e => e.gsv_stsid == 1)
        console.log(filtered_videos, 'before filtered_videos')
        filtered_videos = filtered_videos.map(e => {
          e['gsv_link'] = getVideoId(e?.gsv_link)
          return e
        }
        )

        console.log(filtered_videos, 'filtered_videos')
        setVideoLink(filtered_videos)
        setCurrentVideo(filtered_videos[0])
      } else {
        // toast.error(response.data.body.message, { position: toast.POSITION.TOP_RIGHT });
      }
    } catch (error) {
      // Handle error
      // console.error("student detailsAPI Error:", error);
    } finally {

    }
  }


  const updateDemoTestCount = async () => {
    const user = getLoggedInUser()

    const data = {
      stid: Number(user.UserInfo.stid),
    }
    const config = { headers: { authorization: 'Bearer '.concat(user.UserInfo.accessToken) } };

    try {
      const response = await axios.post(url.BASE_URL + 'subscription/updateDemoTestCount', data, config);
      if (response && response?.data?.body?.statusFlag === 3) {
        toast.error(response.data.body.message, { autoClose: 2000 });
        localStorage.removeItem("authUser");
        window.location.reload();
        return;
      }

      if (response?.data?.body?.status === '401' || response?.data?.body?.status === 401) {
        const refresh = await getRefreshToken();

        if (refresh) {
          if (Number(refresh) === constants.invalidRefreshToken) {
            logoutUser();
          } else {
            await updateDemoTestCount();
          }
        }
      }

      if (response?.data?.body?.statusFlag == 1) {
        navigate("/demotest");
        
      } else {
        // toast.error(response.data.body.message, { position: toast.POSITION.TOP_RIGHT });
      }
    } catch (error) {
      // Handle error
      // console.error("student detailsAPI Error:", error);
    } finally {

    }
  }
  function getVideoId(url) {
    const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
    const match = url?.match(regExp);

    return (match && match[2].length === 11)
      ? match[2]
      : null;
  }
  return (
    <React.Fragment>
      <div className="page-content" style={{ position: 'relative' }}>
        <Container fluid>
       
        {activeSubscriptionExist == 0 && demoFlag == 1 &&  <button className='btn btn-primary' style={{float:'right'}}
  onMouseOver={e => e.currentTarget.style.backgroundColor = '#0056b3'}
  onMouseOut={e => e.currentTarget.style.backgroundColor = '#007bff'}
  onClick={() => { 
updateDemoTestCount() }}
  >
    Demo Test
  </button>}
          {/* Render Breadcrumb */}
          {/* <Breadcrumbs
            title={props.t("Dashboards")}
            breadcrumb
            Item={props.t("Dashboard")}
          /> */}
          <Row>
          {/* <div>
      <h2>Word Document Preview</h2>
      <div dangerouslySetInnerHTML={{ __html: content }} />
    </div> */}
            <Col xl="12" >
              {profilePercent != 100 ? <div className="bg-info-subtle card"><div className="text-info p-3"><h5> <i style={{ fontSize: "20px" }} className="mdi mdi-alert-circle-outline me-2"></i> Please complete your profile for subscribe.</h5></div></div> : null}


            </Col>
            {/* <WelcomeComp /> */}
            {activeSubscriptionExist == 0 ? <WelcomeComp /> : <SubscriptionPlanDetails />}

            {/*            
              <Card style={{height:'100%'}}>

              <div className=" floating-bottom">
                {isDisplayed &&
                  Videolink && Videolink.length > 0 ?
                  <VideoLink Videolink={Videolink} />                  
                  
                  : <img src={profileImg} alt="" className="img-fluid" />}
             
              </div>
              </Card> */}


            {Videolink && Videolink.length > 0 &&

            <Card style={{ height: '100%', position: 'relative' }}>
              <Draggable handle=".drag-handle">
                {/* Floating video or image */}
                <div
                  className="floating-bottom drag-handle" style={{
                    position: 'fixed',
                    bottom: '30px',
                    right: '20px',
                    width: '420px',
                    height: '224px',
                    zIndex: 1000,
                    border: '1px solid #ccc',
                    borderRadius: '8px',
                    overflow: 'hidden',
                    background: '#000',
                    cursor: 'move'
                  }}
                >
                  {Videolink && Videolink.length > 0 ? (
                    <>
                      <VideoLink onSlideChange={(currentIndex) => {

                        setCurrentVideo(Videolink[currentIndex]); // Optional: store in state
                      }} Videolink={Videolink} />
                      <button onClick={() => toggleModal(Videolink)} className="btn btn-light btn-sm" style={{
                        position: 'absolute',
                        top: '5px',
                        right: '5px',
                        borderRadius: '50%',
                        padding: '5px',
                        zIndex: 1001
                      }}>
                        <i className="mdi mdi-fullscreen"></i>

                      </button>
                    </>
                  ) : (
                    <img src={profileImg} alt="" className="img-fluid" />
                  )}
                </div>
              </Draggable>
              {/* Expanded Video Modal */}
              <Modal isOpen={isExpanded} toggle={toggleModal} centered size="lg">
                <ModalBody style={{ padding: 0, position: 'relative' }}>
                  <button onClick={toggleModal} className="btn btn-danger btn-sm" style={{
                    position: 'absolute',
                    top: '10px',
                    right: '10px',
                    zIndex: 1001
                  }}>
                    <i className="mdi mdi-close"></i>
                    {/* <FaTimes /> */}
                  </button>

                  <iframe className="iframeSize"
                    src={"https://www.youtube.com/embed/" + currentVideo?.gsv_link}
                    allow='autoplay; encrypted-media'
                    width="80%"
                    height="400px"
                    allowfullScreen
                    // ref={this.iframeRef}
                    title='video'
                  // id={`video-${item.gsvid}`} 
                  />
                  {/* { "https://www.youtube.com/embed/"+Videolink[0].gsv_link} */}
                  {/* <VideoLink Videolink={Videolink} />     */}
                  {/* <iframe src={"https://www.youtube.com/embed/"+Videolink[0].gsv_link} controls autoPlay style={{ width: '100%', height: 'auto' }} /> */}
                </ModalBody>
              </Modal>
            </Card>

                }
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

Dashboard.propTypes = {
  t: PropTypes.any,
  chartsData: PropTypes.any,
  onGetChartsData: PropTypes.func,
};

export default withTranslation()(Dashboard);
